export const OPERATION_TYPE = {
    'pay': 'pay',
    'refund': 'refund'
}